var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuelManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0052 18.3385V6.67187C14.0052 4.31521 14.0052 3.13604 13.2727 2.40437C12.541 1.67187 11.3619 1.67188 9.00521 1.67188H8.17187C5.81521 1.67188 4.63604 1.67187 3.90437 2.40437C3.17187 3.13604 3.17188 4.31521 3.17188 6.67187V18.3385",
    stroke: "#9C4900",
    strokeOpacity: 0.3,
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83854 5.00781H7.33854C6.55271 5.00781 6.16021 5.00781 5.91604 5.25198C5.67188 5.49615 5.67188 5.88865 5.67188 6.67448C5.67188 7.46031 5.67188 7.85281 5.91604 8.09698C6.16021 8.34115 6.55271 8.34115 7.33854 8.34115H9.83854C10.6244 8.34115 11.0169 8.34115 11.261 8.09698C11.5052 7.85281 11.5052 7.46031 11.5052 6.67448C11.5052 5.88865 11.5052 5.49615 11.261 5.25198C11.0169 5.00781 10.6244 5.00781 9.83854 5.00781Z",
    stroke: "#9C4900",
    strokeOpacity: 0.3,
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5026 14.1693H10.6693M14.8359 18.3359H2.33594M16.9193 3.33594L17.9468 4.1576C18.0618 4.24927 18.1193 4.29594 18.1718 4.3426C18.6643 4.78448 18.9616 5.4036 18.9984 6.06427C19.0026 6.13427 19.0026 6.2076 19.0026 6.35427V15.4193C19.0026 15.7508 18.8709 16.0687 18.6365 16.3032C18.4021 16.5376 18.0841 16.6693 17.7526 16.6693C17.4211 16.6693 17.1031 16.5376 16.8687 16.3032C16.6343 16.0687 16.5026 15.7508 16.5026 15.4193V15.3601C16.5026 14.7018 15.9693 14.1693 15.3118 14.1693H14.0026",
    stroke: "#9C4900",
    strokeOpacity: 0.3,
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.67188H17.75C17.4185 6.67188 17.1005 6.80357 16.8661 7.03799C16.6317 7.27241 16.5 7.59035 16.5 7.92187V9.93771C16.5 10.2001 16.5826 10.4558 16.7361 10.6686C16.8895 10.8815 17.1061 11.0406 17.355 11.1235L19 11.6719",
    stroke: "#9C4900",
    strokeOpacity: 0.3,
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelManagement);
export default __webpack_public_path__ + "static/media/FuelManagement.a59ba4bb02ec72fd65fe68b6f09987e5.svg";
export { ForwardRef as ReactComponent };